module.exports = __webpack_public_path__ + "files/a5177889f775a766a053cc59d6cba022.png";